<template>
  <v-card
    :elevation="2"
    class="my-2 pa-2"
  >
    <div
      class="edit-document__search-blocks"
      v-html="value.content"
    />
    <v-col class="d-flex align-right justify-end pa-0">
      <router-link
        :to="{ path: `/gen-doc-blocks/${value.id}` }"
        target="_blank"
        style="text-decoration: none;"
      >
        <v-btn
          small
          icon
          color="primary"
        >
          <v-icon small>
            edit
          </v-icon>
        </v-btn>
      </router-link>
    </v-col>
    <v-divider class="my-2" />
    <p class="ma-0 red--text text--lighten-2">
      {{ `Версія: ${value.version}` }}
    </p>
    <p
      v-if="value.documentsCount"
      class="ma-0 red--text text--lighten-2"
    >
      <span>{{ getText(value.documentsCount) }}</span>
      <v-btn
        text
        small
        color="primary"
        class="text-capitalize text-underline"
        :disabled="!value.documentsCount"
        @click="$emit('get-items')"
      >
        <v-icon small>
          visibility
        </v-icon>Переглянути
      </v-btn>
    </p>
    <v-btn
      rounded
      small
      dark
      :elevation="0"
      class="red--text text--accent-4 ma-2"
      color="red lighten-5"
      @click="$emit('add')"
    >
      <v-icon small>
        add
      </v-icon>
      {{ btnTitle }}
    </v-btn>
  </v-card>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
    },
    btnTitle: {
      type: String,
      default: "Додати",
    },
  },
  methods: {
    getText(documentsCount) {
      if (documentsCount) {
        return `Знаходиться в ${documentsCount} документ${
          documentsCount > 1 ? "ах" : "і"
        } `;
      } else {
        return;
      }
    },
  },
};
</script>
<style scoped>
.v-card {
  width: 100%;
}
.edit-document__search-blocks {
  max-height: 150px;
  overflow: hidden;
}
</style>
